import { Injectable } from '@angular/core';
import { NbAuthService, NbAuthJWTToken, NbAuthResult } from '@nebular/auth';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

interface User {
  id: string;
  email: string;
  role: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUserSubject = new BehaviorSubject<User | null>(null);
  currentUser$ = this.currentUserSubject.asObservable();

  constructor(
    private nbAuthService: NbAuthService,
    private router: Router,
  ) {
    this.nbAuthService.onTokenChange()
      .subscribe((token: NbAuthJWTToken) => {
        if (token.isValid()) {
          const user = token.getPayload();
          this.currentUserSubject.next({
            id: user.sub,
            email: user.email,
            role: user.role
          });
        } else {
          this.currentUserSubject.next(null);
        }
      });
  }

  logout() {
    // Logout via Nebular Auth (nettoie le token localement)
    return this.nbAuthService.logout('email')
      .pipe(
        tap((result: NbAuthResult) => {
          // Nettoyage local même si l'API échoue
          this.currentUserSubject.next(null);
          localStorage.removeItem('auth_app_token');
          // Redirection vers la page de login
          this.router.navigate(['/auth/login']);
        }),
      ).subscribe();
  }

  getCurrentUser(): User | null {
    return this.currentUserSubject.value;
  }

  isAuthenticated(): boolean {
    return this.currentUserSubject.value !== null;
  }
}